import React from 'react';
import { ScrollText } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#ECEC75] via-[#e6e67c] to-[#ECEC75] py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-black rounded-full mb-6">
            <ScrollText size={40} className="text-[#D4AF37]" />
          </div>
          <h1 className="text-5xl font-bold text-black mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
            Conditions Générales d'Utilisation
          </h1>
          <p className="text-xl text-black/70">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
          </p>
        </div>

        {/* Content */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-8 md:p-12 space-y-8">
          <div className="prose prose-lg max-w-none">
            <div className="p-6 bg-[#D4AF37]/10 rounded-xl mb-8">
              <h3 className="text-xl font-bold text-black mb-2">Bienvenue sur notre site</h3>
              <p className="text-black/70">
                En accédant et en utilisant ce site, vous acceptez d'être lié par les présentes conditions générales d'utilisation.
              </p>
            </div>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">1. Objet</h2>
              <p className="text-black/80 leading-relaxed mb-4">
                Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités et conditions
                d'utilisation du site web du restaurant Le Cosmos Tacos.
              </p>
              <p className="text-black/80 leading-relaxed">
                Ce site a pour objectif de présenter notre restaurant, notre menu et nos services, ainsi que de permettre
                aux visiteurs de nous contacter et de commander via nos partenaires.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">2. Accès au site</h2>
              <p className="text-black/80 leading-relaxed mb-4">
                L'accès au site est gratuit et ouvert à tous. Cependant, nous nous réservons le droit de suspendre,
                modifier ou interrompre l'accès au site sans préavis.
              </p>
              <ul className="list-disc list-inside space-y-2 text-black/80 ml-4">
                <li>Le site est accessible 24h/24, 7j/7, sauf interruption technique</li>
                <li>L'utilisateur est responsable de son équipement et de sa connexion</li>
                <li>Nous ne garantissons pas l'absence de bugs ou d'erreurs</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">3. Utilisation du site</h2>
              <div className="space-y-4">
                <div className="p-4 border-l-4 border-green-500 bg-green-50 rounded-r-lg">
                  <h4 className="font-bold text-black mb-2">✓ Usages autorisés</h4>
                  <ul className="list-disc list-inside space-y-1 text-sm text-black/70">
                    <li>Consultation des menus et informations</li>
                    <li>Prise de contact via formulaire</li>
                    <li>Commander via nos plateformes partenaires</li>
                    <li>Partage sur les réseaux sociaux</li>
                  </ul>
                </div>
                <div className="p-4 border-l-4 border-red-500 bg-red-50 rounded-r-lg">
                  <h4 className="font-bold text-black mb-2">✗ Usages interdits</h4>
                  <ul className="list-disc list-inside space-y-1 text-sm text-black/70">
                    <li>Copie ou reproduction du contenu sans autorisation</li>
                    <li>Utilisation de robots ou scripts automatiques</li>
                    <li>Tentatives de piratage ou d'intrusion</li>
                    <li>Diffusion de contenu illégal ou offensant</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">4. Commandes et livraisons</h2>
              <p className="text-black/80 leading-relaxed mb-4">
                Les commandes et livraisons sont gérées par nos partenaires :
              </p>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="p-4 bg-black/5 rounded-lg">
                  <h4 className="font-bold text-black mb-2">📍 Uber Eats</h4>
                  <p className="text-sm text-black/70">Conditions et tarifs Uber Eats s'appliquent</p>
                </div>
                <div className="p-4 bg-black/5 rounded-lg">
                  <h4 className="font-bold text-black mb-2">🛍️ Deliveroo</h4>
                  <p className="text-sm text-black/70">Conditions et tarifs Deliveroo s'appliquent</p>
                </div>
              </div>
              <p className="text-sm text-black/60 mt-4">
                Note : Le Cosmos Tacos n'est pas responsable des retards ou problèmes de livraison gérés par les plateformes tierces.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">5. Données personnelles</h2>
              <p className="text-black/80 leading-relaxed">
                Vos données personnelles sont traitées conformément à notre 
                <Link to="/privacy" className="text-[#D4AF37] hover:underline mx-1">politique de confidentialité</Link>.
                Nous nous engageons à protéger votre vie privée et à respecter le RGPD.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">6. Propriété intellectuelle</h2>
              <p className="text-black/80 leading-relaxed mb-4">
                Tous les éléments du site (textes, images, logos, vidéos) sont protégés par le droit d'auteur.
              </p>
              <p className="text-black/80 leading-relaxed">
                Toute reproduction, même partielle, sans autorisation préalable, est strictement interdite et constituerait
                une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">7. Responsabilité</h2>
              <p className="text-black/80 leading-relaxed mb-4">
                Le Cosmos Tacos met tout en œuvre pour offrir des informations fiables, mais :
              </p>
              <ul className="list-disc list-inside space-y-2 text-black/80 ml-4">
                <li>Ne peut garantir l'exactitude absolue des informations</li>
                <li>N'est pas responsable des dommages résultant de l'utilisation du site</li>
                <li>Se réserve le droit de modifier les contenus sans préavis</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">8. Modification des CGU</h2>
              <p className="text-black/80 leading-relaxed">
                Nous nous réservons le droit de modifier ces CGU à tout moment. Les modifications entrent en vigueur
                dès leur publication sur le site. Nous vous recommandons de consulter régulièrement cette page.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">9. Droit applicable et juridiction</h2>
              <p className="text-black/80 leading-relaxed">
                Les présentes CGU sont régies par le droit français. En cas de litige, une solution amiable sera recherchée.
                À défaut, les tribunaux français seront compétents.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">10. Contact</h2>
              <p className="text-black/80 leading-relaxed mb-4">
                Pour toute question concernant ces CGU :
              </p>
              <div className="p-6 bg-black text-white rounded-xl">
                <p className="font-bold mb-2">Le Cosmos Tacos</p>
                <p>49 Av. de la Libération, 42000 Saint-Étienne</p>
                <p>Tél : 04 87 66 22 41</p>
              </div>
            </section>
          </div>
        </div>

        {/* Back Button */}
        <div className="text-center mt-8">
          <Link
            to="/"
            className="inline-block bg-black text-white px-8 py-3 rounded-lg font-semibold hover:bg-black/90 transition-colors"
          >
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
